import { $http } from '@/plugins/axios';
import type {
  ServerPagination,
  PaginatedList,
  User,
} from '@/commonTypes';


// export interface PurchasedProductsSummaryData {

// }
export interface PurchasedProductsSummaryResult {
  balance: {
    sample_processing_package: {
      usage: number,
      available: number,
      total: number,
    }
  }
}

export const purchasedProductsSummaryGet = $http.createApiMethod<
  PurchasedProductsSummaryResult
>((config) => $http.get('billing/purchased-products/summary/', config));


export interface PurchasedProductsSummaryData extends ServerPagination {

}
export type PurchasedProductsResult = PaginatedList<{
  product: {
    title: string,
    description: string,
    type: string,
    type_verbose: string,
    amount: 100,
  },
  created_at: string,
  expire_at: string,
  available: string,
  total: string,
  usage: string,
  usages: {
    description: string,
    amount: string,
    created_at: string,
    user: User,
  }[],
}>;

export const purchasedProductsGet = $http.createApiMethod<
  PurchasedProductsResult,
  PurchasedProductsSummaryData
>((data, config) => $http.get(
  'billing/purchased-products/',
  $http.mergeParams(config, data),
));
